/**
 * @flow
 * @format
 */

import React from 'react';
import { Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import { compose, withStateHandlers } from 'recompose';

import type { HOC } from 'recompose';

import classes from './HoverTooltip.scss';

type StatePropsType = {
  showTooltip: boolean,
  hideTip: Function,
  showTip: Function,
  toggle: Function,
};

type OwnPropsType = {
  children: any,
  id: string,
  text: any,
  title: any,
};

type PropsType = OwnPropsType & StatePropsType;

export class HoverTooltip extends React.Component<PropsType, *> {
  static defaultProps = {
    children: <div />,
  };

  shouldComponentUpdate(nextProps: PropsType) {
    return this.props.showTooltip !== nextProps.showTooltip;
  }

  render() {
    return (
      <span className="d-flex ml-auto">
        {/* nested span needed to center tool tip over the children */}
        <span>
          <div
            id={`popover-${this.props.id}`}
            onMouseEnter={this.props.showTip}
            onMouseLeave={this.props.hideTip}
          >
            {this.props.children}
          </div>
        </span>
        <Popover
          placement="right"
          isOpen={this.props.showTooltip}
          target={`popover-${this.props.id}`}
          toggle={this.props.toggle}
        >
          <PopoverHeader className={classes.header}>
            {this.props.title}
          </PopoverHeader>
          <PopoverBody className={classes.body}>{this.props.text}</PopoverBody>
        </Popover>
      </span>
    );
  }
}

const enhancer: HOC<*, OwnPropsType> = compose(
  withStateHandlers(
    { showTooltip: false },
    {
      toggle: ({ showTooltip }) => () => ({ showTooltip: !showTooltip }),
      showTip: () => () => ({ showTooltip: true }),
      hideTip: () => () => ({ showTooltip: false }),
    },
  ),
);

export default enhancer(HoverTooltip);



// WEBPACK FOOTER //
// ./src/components/HoverTooltip/HoverTooltip.js